import UserAvatar from "./user-avatar";

export default UserAvatar;